import { createSelector } from 'reselect';

const sourceInputSelector = store => store.SearchParameter.source.input;
const categoryInputSelector = store => store.SearchParameter.category.input;
const cameraInputSelector = store => store.SearchParameter.camera.input;
const cameraIDInputSelector = store => store.SearchParameter.cameraID.input;
const batchInputSelector = store => store.SearchParameter.batch.input;
const imageSNInputSelector = store => store.SearchParameter.imageSN.input;
const imageSizeSelector = store => store.SearchParameter.imageSize;
const evaluatedImageFilterSelector = store => store.SearchParameter.evaluatedImageFilter;

const categoryMapSelector = store => store.SearchParameter.categoryMap;
const sourceMapSelector = store => store.SearchParameter.sourceMap;
const batchMapSelector = store => store.SearchParameter.batchMap;

export const searchParameterSelector = createSelector(
  sourceInputSelector,
  categoryInputSelector,
  cameraInputSelector,
  cameraIDInputSelector,
  batchInputSelector,
  imageSNInputSelector,
  imageSizeSelector,
  evaluatedImageFilterSelector,
  categoryMapSelector,
  sourceMapSelector,
  batchMapSelector,
  (
    source,
    category,
    camera,
    cameraID,
    batch,
    imageSN,
    imageSize,
    evaluatedImageFilter,
    categoryMap,
    sourceMap,
    batchMap
  ) => {
    const result = {};

    if (source.length) {
      const transformedSource = source.map(name => sourceMap.get(name));
      Object.assign(result, { source: transformedSource });
    }
    if (category.length) {
      const transformedCategory = category.map(name => categoryMap.get(name)).flat();
      Object.assign(result, { category: transformedCategory });
    }
    if (camera.length) {
      Object.assign(result, { camera });
    }
    if (cameraID.length) {
      Object.assign(result, { cameraID });
    }
    if (batch.length) {
      const transformedBatch = batch.map(name => batchMap.get(name));
      Object.assign(result, { batch: transformedBatch });
    }
    if (imageSN.length) {
      Object.assign(result, { imageSN });
    }
    if (imageSize.mode !== 'disabled') {
      const { width, height } = imageSize;
      Object.assign(result, {
        imageSizeMode: imageSize.mode,
        upperWidth: width.max,
        lowerWidth: width.min,
        upperHeight: height.max,
        lowerHeight: height.min
      });
    }
    if (evaluatedImageFilter) {
      Object.assign(result, { evaluatedImageFilter });
    }
    return result;
  }
);

export const searchRequestFormatMappingSelector = createSelector(
  searchParameterSelector,
  ({
    source,
    category,
    cameraID,
    batch,
    imageSN,
    upperWidth,
    lowerWidth,
    upperHeight,
    lowerHeight
    // evaluatedImageFilter
  }) => ({
    source_sn: source,
    category_sn: category,
    camera_id: cameraID,
    batch_sn: batch,
    image_sn: imageSN,
    image_width: {
      upper_bound: upperWidth,
      lower_bound: lowerWidth
    },
    image_height: {
      upper_bound: upperHeight,
      lower_bound: lowerHeight
    }
    // inc_eval: evaluatedImageFilter || undefined
  })
);



// WEBPACK FOOTER //
// ./src/selectors/SearchParameter.Selectors.js